import {useCallback, useEffect, useRef} from 'react';
import {getTabLeftScrollPx} from '../utils/getTabLeftScrollPx.function';
import {useWindowInnerWidth} from './useWindowInnerWidth';

export function useAdjustXAxisScrollPosition(initialItemIndex?: number) {
  const tabRef = useRef<HTMLDivElement | HTMLUListElement>(null);

  const onSelectTabItem = useCallback((selectedItem: HTMLElement) => {
    if (tabRef.current) {
      const tab = tabRef.current;
      let tabLeftPaddingPx = parseInt(window.getComputedStyle(tab).paddingLeft);
      let tabRightPaddingPx = parseInt(
        window.getComputedStyle(tab).paddingRight
      );

      if (isNaN(tabLeftPaddingPx)) {
        tabLeftPaddingPx = 0;
      }
      if (isNaN(tabRightPaddingPx)) {
        tabRightPaddingPx = 0;
      }

      const {left: tabStartX, right: tabEndX} = tab.getBoundingClientRect();
      const tabCenterX = tabStartX + (tabEndX - tabStartX) / 2;

      const {left: currentItemStartX, right: currentItemEndX} =
        selectedItem.getBoundingClientRect();
      const currentItemCenterX =
        currentItemStartX + (currentItemEndX - currentItemStartX) / 2;

      tab.scrollBy({
        left: getTabLeftScrollPx({
          tabWidthPx: tab.offsetWidth,
          tabLeftPaddingPx,
          tabRightPaddingPx,
          tabCenterX,
          currentItemCenterX,
          totalScrollWidthPx: tab.scrollWidth,
          currentScrolledWidthPx: tab.scrollLeft,
          firstChildWidthPx: (tab.firstChild as HTMLElement).offsetWidth,
          lastChildWidthPx: (tab.lastChild as HTMLElement).offsetWidth,
        }),
        behavior: 'smooth',
      });
    }
  }, []);

  const width = useWindowInnerWidth(); // 너비가 변경될 때 포지션을 다시 조정하기 위함
  useEffect(() => {
    if (tabRef.current && initialItemIndex !== undefined) {
      const tabItems = Array.from(tabRef.current.children);
      const initialTabItem = tabItems[initialItemIndex];
      if (initialTabItem) {
        onSelectTabItem(initialTabItem as HTMLElement);
      }
    }
  }, [onSelectTabItem, width, initialItemIndex]);

  return {
    tabRef,
    onSelectTabItem,
  };
}
